export default class ImportError extends Error {
  constructor(mess) {
    super();
    this.name = 'ImportError';
    this.message = mess || 'Ocorreu um problema ao importar';
  }
}
